import BaseApi from "../BaseApi";

const baseApi = new BaseApi();

export default class Exports {
  Entity = "exports";

  begin = async (data = null) => {
    if (!data) {
      throw new Error("Data is null...!!!")
    }

    const action = "begin";
    const processedData = {
      file_format: data?.fileFormat,
      media: data?.media,
      studies: data?.studies,
      viewer: data?.viewer,
      anonymous: data?.anonymous
    };

    return baseApi.customCreate(processedData, {entity: this.Entity, action: action});
  }

  status = async (data = null) => {
    if (!data) {
      throw new Error("Data is null...!!!");
    }

    const action = "status";
    const processedData = {
      study_id: data?.studyID,
    };

    return baseApi.customCreate(processedData, {entity: this.Entity, action: action});
  }
}
